module.exports = __webpack_public_path__ + "static/media/custom-ex-12.94b8f3ce.jpg";